import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { VisitRow } from "@/lib/database.types";

export function useVisits(patientId: string | undefined) {
  return useQuery<VisitRow[]>({
    queryKey: ["visits", patientId],
    enabled: !!patientId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("visits")
        .select("*, provider:providers(id,full_name)")
        .eq("patient_id", patientId!)
        .order("scheduled_at", { ascending: false, nullsFirst: false });
      if (error) throw error;
      return (data as VisitRow[] | null) ?? [];
    },
  });
}
